import React from 'react';
import PropTypes from 'prop-types';
import Description from './Description';
import Languages from './Languages';
import SkillTests from './SkillTests';
import LinkedAccounts from './LinkedAccounts';
import Skills from './Skills';
import ProfessionalPresence from './ProfessionalPresence';
import SocialPresence from './SocialPresence';
import EducationList from './EducationList';
import Certifications from './Certifications';
import Appearances from './Appearances';
import Clients from './Clients';
import WithImpressions from '../../WithImpressions';
import './index.scss';

export default function SellerProfile({
    description,
    languages,
    skillTests,
    identities,
    skills,
    professional_presences,
    online_presences,
    educations,
    certifications,
    appearances,
    clients,
    biData
}) {
    const seller_card_about_me_component = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_component_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_list' },
            element: {
                name: 'seller_card_about_me_component',
                visible: true
            }
        }
    };
    return (
        <WithImpressions className="seller-profile" value={seller_card_about_me_component}>
            <Description description={description} biData={{...biData, position: 1}}/>
            <Languages languages={languages} biData={{...biData, position: 2}}/>
            <SkillTests tests={skillTests} biData={{...biData, position: 3}}/>
            <LinkedAccounts socialAccounts={identities} biData={{...biData, position: 4}}/>
            <Skills skills={skills} biData={{...biData, position: 5}}/>
            <ProfessionalPresence professionalPresence={professional_presences}/>
            <SocialPresence socialPresence={online_presences}/>
            <EducationList educations={educations} biData={{...biData, position: 8}}/>
            <Certifications certifications={certifications} biData={{...biData, position: 9}}/>
            <Appearances appearances={appearances}/>
            <Clients clients={clients}/>
        </WithImpressions>
    );
}

SellerProfile.propTypes = {
    description: PropTypes.string,
    languages: PropTypes.array,
    identities: PropTypes.array,
    skills: PropTypes.array,
    professional_presences: PropTypes.array,
    online_presences: PropTypes.array,
    educations: PropTypes.array,
    certifications: PropTypes.array,
    appearances: PropTypes.array,
    clients: PropTypes.array,
    biData: PropTypes.object
};

SellerProfile.defaultProps = {
    description: '',
    languages: [],
    identities: [],
    skills: [],
    professional_presences: [],
    online_presences: [],
    educations: [],
    certifications: [],
    appearances: [],
    clients: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/index.js